/***********************************************
  IceMedX - Developed By IceMedx Corporation
  Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { medicalservice } from './medicalservice';

export class medicalserviceindex extends medicalservice {
  medical_service_index_key: string = "";
  medical_service_key: string = "";
  date_required: any = NaN;
  end_date_required: any = NaN;
  all_modifiers: string = "";
  other_items_key: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  code: string = "";
  price: number = 0.0;
  unit_code: string = "";
  quantity: number = 0.0;
  total_amount: number = 0.0;
  service_description: string = "";
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  referral_key: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  copay_service_key: string = "";
  prescription_key: string = "";
  trans_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  additional_note: string = "";

  constructor() {
    super();
  }

  copyservice(svc: medicalservice): medicalserviceindex {
    if (svc == null) return null;
    this.medical_service_key = svc.medical_service_key;
    if (svc.SVCDTS != null && svc.SVCDTS.length > 0) {
      this.date_required = svc.SVCDTS[0].date_required;
      this.end_date_required = svc.SVCDTS[0].end_date_required;
    }
    this.all_modifiers = [svc.modifier1, svc.modifier1, svc.modifier1, svc.modifier1].join(",");
    this.other_items_key = svc.other_items_key;
    this.account_type = svc.account_type;
    this.trans_account = svc.trans_account;
    this.code = svc.code;
    this.price = svc.price;
    this.unit_code = svc.unit_code;
    this.quantity = svc.quantity;
    this.total_amount = svc.total_amount;
    this.service_description = svc.service_description;
    this.tax_status = svc.tax_status;
    this.referral_key = svc.referral_key;
    this.subscriber_key = svc.subscriber_key;
    this.coverage_key = svc.coverage_key;
    this.payer_key = svc.payer_key;
    this.copay_service_key = svc.copay_service_key;
    this.prescription_key = svc.prescription_key;
    this.trans_status = svc.trans_status;
    this.additional_note = svc.additional_note;
    return this;
  }

  gettablename(): string {
    return "MEDICAL_SERVICE_INDEX";
  }
}
